import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import debounce from "lodash.debounce";
import Swal from "sweetalert2";

import GenericTableComponent from "../common/Table";
import { getAllAdvertiser, statusAdvertiser } from "../../redux/slices/advertiserSlice";
//import { convertToLocalCurrency } from '../../utils/currency';

import infoIcon from "../../assets/icons/infoIcon.svg"

const columns = [
  { id: "user", label: "Advertiser" },
  { id: "campaignCount", label: "Campaigns" },
  { id: "userApproved", label: "Approval" },
  { id: "usercreatedAt", label: "Date created" },
  //{ id: "campaign_reach", label: "Clicks" },
];
const AllAdvertisers = () => {
  const dispatch = useDispatch();
  const { advertisers, meta, loading } = useSelector((state) => state.advertiser);
  //console.log(meta)
  
//console.log(advertisers)
  
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(getAllAdvertiser({ page, rowsPerPage }));
  }, [dispatch, page, rowsPerPage]);

  const handlePageChange = (event, newPage) => {
      setPage(newPage);
  };
  
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((searchTerm) => {
        dispatch(getAllAdvertiser({ page: 0, rowsPerPage, name: searchTerm }));
      }, 2000),
    [dispatch, rowsPerPage]
  );

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearch(value);
    debouncedSearch(value);
  };

  const triggerSearch = () => {
    
    dispatch(getAllAdvertiser({ page: 0, rowsPerPage, name: search }));
  };

  // const handleFilterChange = (value) => {
  //   // let boolValue;
  //   // if (value === "ACTIVATED") {
  //   //   boolValue = true;
  //   // } else if (value === "DEACTIVATED") {
  //   //   boolValue = false;
  //   // } else {
  //   //   boolValue = null;
  //   // }
  //   dispatch(getAllAdvertiser({ page: 0, rowsPerPage, state: value }));
  // };

  // const handleActiveState = (id) => {
  //   dispatch(statusAdvertiser(id))
  //   .unwrap()
  //   .then(() => {
  //     dispatch(getAllAdvertiser({ page, rowsPerPage }));
  //   })
  //   .catch((error) => {
  //     console.error("Failed to update advertiser status:", error);
  //   });
  // };

  const handleApproveClick = (id) => {
    dispatch(statusAdvertiser({id, state: "APPROVED"}))
    .unwrap()
    .then(() => {
      dispatch(getAllAdvertiser({ page, rowsPerPage }));
    })
    .catch((error) => {
      console.error("Failed to update advertiser status:", error);
    });
  }

const handleRejectClick = (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You are about to reject this advertiser. This action cannot be undone.",
    icon: null, 
      iconHtml:
          `<img src=${infoIcon} alt="error" style="width:50px;">`,
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, Reject",
    cancelButtonText: "Cancel",
  }).then((result) => {
    if (result.isConfirmed) {
      dispatch(statusAdvertiser({ id, state: "REJECTED" }))
        .unwrap()
        .then(() => {
          dispatch(getAllAdvertiser({ page, rowsPerPage }));
          //Swal.fire("Rejected!", "The advertiser has been rejected.", "success");
        })
        .catch((error) => {
          console.error("Failed to update advertiser status:", error);
          //Swal.fire("Error!", "There was an error rejecting the advertiser.", "error");
        });
    }
  });
};


  return (
    <div>
      {loading ? (
        <div> </div>
      ) : (
        <GenericTableComponent
          columns={columns}
          data={advertisers}
          filterSearch={true}
          paginate={true}
          user
          viewLink="/view-advertiser"
          editLink="/edit-advertiser"
          page={page}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          triggerSearch={triggerSearch}
          search={search}
          handleRowsPerPageChange={handleRowsPerPageChange}
          handleSearchChange={handleSearchChange}
          totalItems={meta?.itemCount || 0}
          //onFilterChange={handleFilterChange}
          //handleActiveState={handleActiveState}
          hideDateSearch
          hideActiveSearch
          handleApproveClick={handleApproveClick}
          handleRejectClick={handleRejectClick}
        />
      )}
    </div>
  );
};

export default AllAdvertisers;
